import { gql } from "@apollo/client"
import {
  useAllPriceBenchmarkDataQuery,
  useVarietyGroupBenchmarkDataQuery,
} from "generated/graphql"
import { useSelector } from "react-redux"
import { ApplicationState } from "store"
import {
  useFilter,
  useSearchQuery_DEPRECATED,
} from "store/search-filter/search-filter.reducer"

export const ALL_PRICE_BENCHMARK_DATA = gql`
  query AllPriceBenchmarkData(
    $first: Int
    $skip: Int
    $query: String
    $filter: PriceBenchmarkDataQueryInput
  ) {
    allPriceBenchmarkData(
      first: $first
      skip: $skip
      filter: $filter
      query: $query
    ) {
      id
      metadata {
        id
        date
        commodityGroup {
          id
          name
        }
        seller {
          id
          name
          category
          categoryObj @client {
            id
            name
          }
        }
        marketYard {
          id
          name
          address {
            id
            village
          }
        }
      }

      grade {
        id
        name
      }

      photos {
        id
        createdAt
        url
      }
      gradePrices {
        pricingDoneOn
        id
        price
        priceUnit {
          id
          name
        }
        uomType {
          id
          codename
          name
        }
        rejection
      }
    }
  }
`

export const VARIETY_GROUP_BENCHMARK_DATA = gql`
  query VarietyGroupBenchmarkData(
    $first: Int
    $skip: Int
    $query: String
    $filter: PriceBenchmarkRecommendationFilterInput
  ) {
    allPriceBenchmarkRecommendations(
      first: $first
      skip: $skip
      filter: $filter
      query: $query
    ) {
      id
      date
      benchmarkType
      grade {
        id
        name
      }
      commodityGroup {
        id
        name
        isKeyValueProduct
        codename
      }
      grade {
        id
        name
      }
      marketYard {
        id
        name
        address {
          id
          village
        }
      }
      recommendedPrice {
        id
        price
        pricingDoneOn
        priceUnit {
          id
          name
        }
        uomType {
          id
          name
        }
      }
      averagePrice {
        id
        price
        pricingDoneOn
        priceUnit {
          id
          name
        }
        uomType {
          id
          name
        }
      }
    }
  }
`
export function useAllPriceBenchmarkData() {
  const [filter] = useFilter("benchmarks")
  const [query] = useSearchQuery_DEPRECATED("benchmarks")

  const page = useSelector<ApplicationState, number>(
    state => state.searchFilter.benchmarks.page
  )
  return useAllPriceBenchmarkDataQuery({
    variables: {
      first: 15,
      skip: page * 15,
      query,
      filter: {
        date_Lte: filter?.dateRange?.[0],
        date_Gte: filter?.dateRange?.[1],
        benchmarkType: filter?.benchmarkType?.id,
        marketYardId: filter?.marketYardId?.id,
        commodityGroupId: filter?.commodityGroupId?.id,
        benchmarkDoneById: filter?.benchmarkDoneById?.id,
        gradeId: filter?.gradeId?.id,
        pricingDoneOn: filter?.pricingDoneOn?.id,
        rejection: filter?.rejection,
        recommendedBenchmarkRate: filter?.recommendedBenchmarkRate,
      },
    },
  })
}

export function useBenchmarkRecommendations(
  commodityGroup?: string,
  groups?: any,
  first?: number
) {
  return useVarietyGroupBenchmarkDataQuery({
    variables: {
      first,
      filter: {
        commodityGroup,
        benchmarkTypes: groups,
      },
    },
  })
}
